import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { observable } from 'mobx';

export class JourneyContinuationIdStore extends Store {
  @observable public journeyContinuationId: string;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}

JourneyContinuationIdStore.DEFAULTS = {
  journeyContinuationId: null
};
